<template>
  <div class="header">
    <header class="elHeader">
      <img :src="logoSrc" />
      <!-- <el-menu :default-active="activeHeader" class="el-menu-demo" mode="horizontal" background-color="#212a32" text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item index="order" @click="router.push('/order/manage')">
          订单管理
        </el-menu-item>
        <el-menu-item index="stock" @click="router.push('/stock/manage')">
          库存管理
        </el-menu-item>
        <el-menu-item index="basic" @click="router.push('/basic/classify')">
          基础设置
        </el-menu-item>
        <el-menu-item index="4" :disabled="true">统计报表</el-menu-item>
      </el-menu>-->
      <div class="rightbtn">
        <afterMsgPop />
        <div>
          <el-popover
            placement="bottom"
            width="280"
            trigger="click"
            v-model="popoverVisible"
          >
            <div class="my-popover">
              <popoverTitle
                @onSearch="onAlertMsgSearch"
                @onChange="onSearchClear"
              ></popoverTitle>
              <div
                v-if="alertMsgLists.length === 0"
                class="my-popover empty-wrapper"
              >
                <img :src="noData" alt="" />
                <p>暂无数据</p>
              </div>
              <popoverContent
                v-else
                :lists="alertMsgLists"
                @onJumpto="onJumpto"
              ></popoverContent>
            </div>
            <el-badge :is-dot="forAlertLists.length > 0" slot="reference">
              <span style="font-size: 12px">
                <!-- <i class="el-icon-bell" style="font-size:12px;"></i> -->
                锐锢在线
              </span>
            </el-badge>
          </el-popover>
        </div>
        <div>
          <el-checkbox v-model="ifNews">
            <span style="color: #d7dee4; font-size: 13px"> 新订单提醒 </span>
          </el-checkbox>
        </div>
        <div>
          <!-- <span slot="reference" style="font-size:12px;"><i class="el-icon-bell" style="font-size:12px;"></i>消息</span> -->
          <el-badge
            :value="sysMessage.length"
            is-dot
            :hidden="sysMessage.length === 0"
          >
            <el-popover
              placement="bottom"
              width="600"
              trigger="click"
              :offset="30"
              @show="show"
              @hide="hide"
            >
              <div
                class="message-wrap"
                v-loading="!showMessage"
                :style="{ 'min-height': minheight }"
              >
                <div v-if="showMessage">
                  <div class="title">
                    <div>新消息通知</div>
                    <div>
                      <el-radio-group
                        v-model="radioMessage"
                        size="mini"
                        @change="changeRadioMessage"
                      >
                        <el-radio-button label="未读消息"></el-radio-button>
                        <el-radio-button label="已读消息"></el-radio-button>
                      </el-radio-group>
                    </div>
                  </div>
                  <el-collapse accordion v-if="radioMessage === '未读消息'">
                    <div v-for="item in sysMessage" :key="item.id">
                      <div v-if="item.list" class="message-item-el-collapse">
                        <el-collapse-item :name="item.id">
                          <template slot="title">
                            <div class="message-item">
                              <div class="message-item-head">
                                <div>
                                  {{ item.typeName }}
                                </div>
                                <div>
                                  <span style="font-size: 12px" class="no-mark">
                                    {{ item.created_at }}
                                  </span>
                                  <span
                                    class="mark"
                                    style="font-size: 12px"
                                    @click="readMessage(item)"
                                  >
                                    <a type="text">标记已读</a>
                                  </span>
                                </div>
                              </div>
                              <div class="message-item-content">
                                定时同步库存错误
                              </div>
                            </div>
                          </template>
                          <div
                            v-for="detail in item.list"
                            :key="detail.sku_code"
                            class="message-item-kucun"
                          >
                            <span>sku:{{ detail.sku_code }}:</span>
                            <span>定时同步库存错误</span>
                          </div>
                        </el-collapse-item>
                      </div>
                      <div
                        class="message-item"
                        style="border-bottom: 1px solid #ebeef5"
                        v-else
                      >
                        <div class="message-item-head common-message">
                          <div>
                            {{ item.typeName }}
                          </div>
                          <div>
                            <span style="font-size: 12px" class="no-mark">
                              {{ item.created_at }}
                            </span>
                            <span
                              class="mark"
                              style="font-size: 12px"
                              @click="readMessage(item)"
                            >
                              <a type="text">标记已读</a>
                            </span>
                          </div>
                        </div>
                        <div class="message-item-content">
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                    <div v-if="sysMessage.length === 0" class="no-message">
                      暂无未读消息
                    </div>
                  </el-collapse>
                  <el-collapse accordion v-else>
                    <div v-for="item in sysReadMessage" :key="item.id">
                      <div v-if="item.list" class="message-item-el-collapse">
                        <el-collapse-item :name="item.id">
                          <template slot="title">
                            <div class="message-item">
                              <div class="message-item-head">
                                <div>
                                  {{ item.typeName }}
                                </div>
                                <div>
                                  <span style="font-size: 12px" class="no-mark">
                                    {{ item.created_at }}
                                  </span>
                                  <span
                                    class="mark"
                                    style="font-size: 12px"
                                    @click="deleteMessage(item)"
                                  >
                                    <a
                                      type="text"
                                      style="font-size: 12px; color: red"
                                      >删除已读</a
                                    >
                                  </span>
                                </div>
                              </div>
                              <div class="message-item-content">
                                定时同步库存错误
                              </div>
                            </div>
                          </template>
                          <div
                            v-for="detail in item.list"
                            :key="detail.sku_code"
                            class="message-item-kucun"
                          >
                            <span>sku:{{ detail.sku_code }}:</span>
                            <span>定时同步库存错误</span>
                          </div>
                        </el-collapse-item>
                      </div>
                      <div
                        class="message-item"
                        style="border-bottom: 1px solid #ebeef5"
                        v-else
                      >
                        <div class="message-item-head common-message">
                          <div>
                            {{ item.typeName }}
                          </div>
                          <div>
                            <span style="font-size: 12px" class="no-mark">
                              {{ item.created_at }}
                            </span>
                            <span
                              class="mark"
                              style="font-size: 12px"
                              @click="deleteMessage(item)"
                            >
                              <a type="text" style="font-size: 12px; color: red"
                                >删除已读</a
                              >
                            </span>
                          </div>
                        </div>
                        <div class="message-item-content">
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                    <div v-if="sysReadMessage.length === 0" class="no-message">
                      暂无已读消息
                    </div>
                  </el-collapse>
                </div>
              </div>
              <span slot="reference" style="font-size: 12px"
                ><i class="el-icon-bell" style="font-size: 12px"></i>消息</span
              >
            </el-popover>
          </el-badge>
        </div>
        <div>
          <span @click="logout" class="logout" style="font-size: 12px"
            ><i class="iconfont icon-tuichu" style="font-size: 12px"></i
            >退出</span
          >
        </div>
      </div>
    </header>
    <div v-if="showAsDiglog"><PendingAsOrderDialog /></div>
  </div>
</template>
<script>
import { audioOrder } from "@/models/commonModel";
import { eventBus } from "@/event-bus.js";
import { mapGetters } from "vuex";
import { setTimeout } from "timers";
import { getChatGroups } from "@/models/exceptionModel";
import popoverContent from "@/components/basic/popover/popoverContent";
import popoverTitle from "@/components/basic/popover/popoverTitle";
import afterMsgPop from "./afterMsgPop";
import PendingAsOrderDialog from "@/components/pendingAsOrder"; //强提醒售后消息弹框

export default {
  data() {
    return {
      activeIndex: "1",
      logoSrc: require("@/assets/img/logo.jpg"),
      ifNews: localStorage.getItem("ifNews") === "true",
      newsInterval: "",
      messageDialog: false,
      radioMessage: "未读消息",
      showMessage: false,
      minheight: "300px",

      appCode: 1, // 1，异常单
      forAlertLists: [], // 用于顶部未读消息小红点
      alertMsgLists: [], // 未读消息列表
      hasUnReadAmount: 1, // 是否需要未读信息：1、需要 0、不需要
      history: 0, // 是否需要过期群组,1:需要 0:不需要
      noData: require("@/assets/img/no-data.png"),
      popoverVisible: false,
      showAsDiglog: false
    };
  },
  components: {
    popoverContent,
    popoverTitle,
    afterMsgPop,
    PendingAsOrderDialog
  },
  computed: {
    ...mapGetters(["sysMessage", "sysReadMessage"]),
    activeHeader() {
      if (this.$route.path.search("basic") !== -1) {
        return "basic";
      } else if (this.$route.path.search("order") !== -1) {
        return "order";
      } else if (this.$route.path.search("stock") !== -1) {
        return "stock";
      }
    }
  },
  watch: {
    ifNews(val) {
      this.getNews(val);
      localStorage.setItem("ifNews", val);
    }
  },
  mounted() {
    this.getNews(this.ifNews);
    this.openMessage();
    this.showAsDiglog = true;
    this.getChatId();
    if (this.myChatId) {
      this.getAlertMsg(); // 获取群列表
    } else {
      const T = setInterval(() => {
        this.getChatId();
        if (this.myChatId) {
          clearInterval(T);
          this.getAlertMsg();
        }
      }, 100);
    }
    eventBus.$on("updateAlertList", () => {
      console.log("顶部收到updateAlertList刷新列表的通知");
      this.getAlertMsg();
    });
    eventBus.$on("rcdMsg", message => {
      if (
        JSON.parse(message).action === "sendMsg" ||
        JSON.parse(message).action === "addGroup"
      ) {
        console.log("顶部收到action === sendMsg 的刷新列表的通知");
        this.getAlertMsg();
      }
    });
  },
  methods: {
    show() {
      this.showMessage = false;
      setTimeout(() => {
        this.showMessage = true;
        this.minheight = "100px";
      }, 100);
    },
    hide() {
      this.showMessage = false;
      setTimeout(() => {
        this.minheight = "300px";
      }, 500);
    },
    goOrder() {
      if (localStorage.getItem("is_jgj") === "1") {
        // 为紧固件
        this.$router.push("/order/manageFastener");
      } else {
        this.$router.push("/order/manage");
      }
    },
    getNews(val) {
      if (val) {
        this.newsInterval = setInterval(async () => {
          if (localStorage.getItem("token")) {
            let data = await audioOrder();
            if (data !== 0) {
              new Audio(
                "http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=你有新的锐锢订单啦"
              ).play();
              if (localStorage.getItem("is_jgj") === "1") {
                // 为紧固件
                this.$router.push("/order/manageFastener");
              } else {
                this.$router.push("/order/manage");
              }
              eventBus.$emit("updateOrder");
              this.$notify({
                dangerouslyUseHTMLString: true,
                position: "bottom-right",
                message: '<a href="#">你有新的锐锢订单啦</a>',
                onClick: this.goOrder
              });
            }
          }
        }, 30000);
      } else {
        clearInterval(this.newsInterval);
      }
    },
    openMessage() {
      this.$store.dispatch("app/changeMessage");
    },
    readMessage(item) {
      this.$store.dispatch("app/updateMessage", item);
    },
    deleteMessage(item) {
      this.$store.dispatch("app/deleteMessage", item);
    },
    logout() {
      this.$store.dispatch("user/logout");
      this.$store.dispatch("app/clearInterval");
    },
    changeRadioMessage(val) {
      if (val === "未读消息") {
        this.$store.dispatch("app/changeMessage");
      } else {
        this.$store.dispatch("app/changeReadMessage");
      }
    },
    /**
     * @description: 获取未读消息列表
     * @param {*}
     * @return {*}
     */
    getAlertMsg() {
      const params = {
        appCode: this.appCode,
        "fromUser.chatId": this.myChatId,
        hasUnReadAmount: this.hasUnReadAmount,
        history: this.history
        // useId: store.get('myUserId'),
        // userType: this.userType,
      };
      getChatGroups(params)
        .then(res => {
          const result = res || [];
          const alertList = [];
          for (const list of result) {
            if (list.unreadAmount > 0) {
              alertList.push(list);
            }
          }
          this.alertMsgLists = this.forAlertLists = this.tempAlertMsgLists = alertList;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    /**
     * @description: 搜索未读消息列表
     * @param {*}
     * @return {*}
     */
    onAlertMsgSearch(text) {
      const value = text.trim();
      if (value === "") {
        this.onSearchClear(); // 输入框点击清除按钮
        return;
      }
      // this.tempAlertMsgLists = this.alertMsgLists;
      if (!value) {
        this.$message.error("请输入搜索单号！");
        return false;
      }
      const tempList = [];
      for (const list of this.alertMsgLists) {
        if (list.groupTitle === value) {
          tempList.push(list);
        }
      }
      this.alertMsgLists = tempList;
    },
    /**
     * @description: 清空输入框
     * @param {*}
     * @return {*}
     */
    onSearchClear() {
      this.alertMsgLists = this.tempAlertMsgLists;
      // this.tempAlertMsgLists = [];
    },
    /**
     * @description: 跳转详情
     * @param {*}
     * @return {*}
     */
    onJumpto(item) {
      this.popoverShow = false;
      this.$router.push({ path: `/orderList/chat?keyWord=${item.groupTitle}` });
      this.popoverVisible = false;
      this.getAlertMsg(); // 刷新顶部未读列表
    },
    /**
     * @description: 获取 chatId
     * @param {*}
     * @return {*}
     */
    getChatId() {
      this.myChatId = localStorage.getItem("myChatId") || "";
    }
  },
  destroyed() {
    eventBus.$off("updateAlertList");
    eventBus.$off("rcdMsg");
  }
};
</script>
<style lang="scss" scoped>
$commonFontSize: 14px;
.elHeader {
  display: flex;
  background-color: #212a32;
  position: fixed;
  z-index: 3;
  width: 100%;
  top: 0;
  a {
    text-decoration: unset;
  }
  img,
  .el-menu--horizontal > .el-menu-item {
    height: 48px;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    background-color: #eb5729 !important;
    color: #d7dee4 !important;
    border: none;
    font-size: $commonFontSize;
  }
  .el-menu--horizontal > .el-menu-item {
    font-size: $commonFontSize;
    line-height: 48px;
  }
  .el-menu.el-menu--horizontal {
    border: none;
  }
  .rightbtn {
    position: fixed;
    right: 0;
    top: 15px;
    display: flex;
    align-items: center;
    color: #d7dee4;
    div {
      margin-right: 20px;
      font-size: 12px;
      cursor: pointer;
    }
    i {
      margin-right: 5px;
    }
    .el-checkbox,
    span {
      color: #d7dee4;
    }
  }
}
.message-wrap {
  max-height: 600px;
  display: block;
  overflow-y: auto;
  .title {
    div:nth-child(2) {
      margin: 5px 0;
    }
    text-align: center;
    font-size: 20px;
  }
  .badge {
    display: inline-block;
    height: 10px;
    width: 10px;
    background: #eb5729;
    border-radius: 50%;
    margin-right: 3px;
    line-height: 10px;
  }
  .badge-active {
    display: inline-block;
    height: 10px;
    width: 10px;
    background: #31da56;
    border-radius: 50%;
    margin-right: 3px;
    line-height: 10px;
  }
  .message-list {
    display: flex;
  }
  .message-item {
    width: 100%;
    color: #303133;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    padding: 5px 0;
    outline: 0;
    .common-message {
      div:nth-child(2) {
        margin-right: 35px;
      }
    }
    &-head {
      display: flex;
      justify-content: space-between;
      line-height: 20px;
      color: #888;
      font-size: 12px;
      .mark {
        display: none;
        a {
          text-decoration: none;
          font-size: 12px;
          color: #006eff;
          padding: 0;
          margin: 0;
        }
      }
      div:nth-child(2) {
        margin-right: 10px;
      }
    }
    &-head:hover {
      .mark {
        display: inline-block;
      }
      .no-mark {
        display: none;
      }
    }
    &-content {
      color: #000;
      padding: 4px 0 0;
      line-height: 21px;
      max-height: 21px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      font-size: 12px;
    }
  }
  .message-item-el-collapse {
    border-bottom: 1px solid #ebeef5;
  }
  .message-item-kucun {
    cursor: pointer;
  }
  .no-message {
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
  }
}
.my-popover {
  min-height: 300px;
}
.empty-wrapper {
  text-align: center;
  min-height: 200px;
  padding-top: 35%;
  img {
    width: 54px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header.vue